import {
  InlineFilterLoading,
  NavigationTreeLoading,
  StreamHeaderLoading,
} from '@aboutyou/logic-components';
import {Grid, PlaceholderTiles, SplitView} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const CouponActivationPage: React.FC = () => {
  return (
    <>
      <StyledSplitView
        split={'30:70'}
        splitMedium={'20:80'}
        splitLarge={'15:85'}
        contentStart={<NavigationTreeLoading />}
        contentEnd={
          <>
            <StreamHeaderLoading />
            <InlineFilterLoading />
            <StyledGrid>
              <PlaceholderTiles amount={32} />
            </StyledGrid>
          </>
        }
      />
    </>
  );
};

const StyledGrid = styled(Grid)`
  padding-inline: 16px;
`;

const StyledSplitView = styled(SplitView)`
  padding-top: 28px;
`;
